import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { IProfileEntityDetail } from '@boma/supplier-portal/shared/entities';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { HasPermissionsDirective } from '../directives/has-permissions.directive';
import { getSelectedOrganizationInfo } from './../../../../supplier-portal/shared/state/src/lib/user/user.selectors';

@Component({
  selector: 'boma-portal-menu',
  templateUrl: './portal-menu.component.html',
  providers: [HasPermissionsDirective],
  styleUrls: ['./portal-menu.component.scss'],
})
export class PortalMenuComponent implements OnInit, OnDestroy {
  organization$: Observable<any>;
  organizationSubscription: Subscription;
  selectedEntityDetails: IProfileEntityDetail;
  organizationPermissions: any;

  loaded = false;

  @Input() isHorizontal = false;

  @Input() menuItems;

  @Input() isSlim = false;

  @Input() isMobile = false;

  @Input() isDesktop = false;

  @Input() tagLine;

  @Input() isMenuHoverActive = false;

  @Input() adminDash = false;

  @Output() handleMenuClick = new EventEmitter();

  @Output() handleMenuHoverActive = new EventEmitter();
  @Output() handleMenuHoverActiveFalse = new EventEmitter();
  @Output() handleUnblockBodyScroll = new EventEmitter();
  @Output() handleStaticMenuMobileActiveFalse = new EventEmitter();

  constructor(private store: Store) {}

  ngOnInit(): void {
    if (!this.adminDash) {
      this.organizationSubscription = this.store
        .select(getSelectedOrganizationInfo)
        .subscribe((x: IProfileEntityDetail) => {
          if (!x) return;
          this.selectedEntityDetails = x;
          this.organizationPermissions = x.permissions;
          this.loaded = true;
        });
    } else {
      this.loaded = true;
    }
  }

  checkPermissions(item) {
    if (item.permission) {
      return this.organizationPermissions.some((x) => x === item.permission);
    } else {
      return true;
    }
  }

  handleSetMenuHoverActive() {
    this.handleMenuHoverActive.emit();
  }

  handleSetMenuHoverActiveFalse() {
    this.handleMenuHoverActiveFalse.emit();
  }

  unblockBodyScroll() {
    this.handleUnblockBodyScroll.emit();
  }

  staticMenuMobileActiveFalse() {
    this.handleStaticMenuMobileActiveFalse.emit();
  }

  ngOnDestroy() {
    this.organizationSubscription?.unsubscribe();
  }
}
